import React from 'react';

interface DonutChartProps {
  segments: Array<{ label: string; value: number; color: string }>;
  size?: number;
  thickness?: number;
}

export const DonutChart: React.FC<DonutChartProps> = ({ segments, size = 180, thickness = 22 }) => {
  const total = Math.max(1, segments.reduce((s, x) => s + x.value, 0));

  let cumulative = 0;
  const gradient = segments.map((seg) => {
    const start = (cumulative / total) * 100;
    const end = ((cumulative + seg.value) / total) * 100;
    cumulative += seg.value;
    return `${seg.color} ${start}%, ${seg.color} ${end}%`;
  }).join(', ');

  const style: React.CSSProperties = {
    width: size,
    height: size,
    background: `conic-gradient(${gradient || '#e5e7eb 0%, #e5e7eb 100%'})`,
    borderRadius: '50%'
  };

  const innerStyle: React.CSSProperties = {
    width: size - thickness * 2,
    height: size - thickness * 2,
  };

  return (
    <div className="relative inline-block" style={style}>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white rounded-full" style={innerStyle}></div>
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-sm text-gray-600">{total} Total</div>
      </div>
    </div>
  );
};
